/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-10 11:39:10
 *
 *******************************************************/
// @flow
import React from 'react';

const EmbeddedVideo = ({ width, height }) => {
  return (
    <iframe
      width={width}
      height={height}
      src="https://www.youtube.com/embed/HKwjYsa342w?si=aAJb98sFUHZD3Jrj"
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen></iframe>
  );
};

export default EmbeddedVideo;
